<script>
export default {
  props: {
    module: Object,
  },
  data: () => ({
    message: '',
  }),
  computed: {
    value: {
      get() {
        return !!this.module.open;
      },
      set() {
        this.module.open = null;
      },
    },
  },
  methods: {
    send() {
      this.module.send(this.module.open, this.message);
      console.log(this.message);
    },
  },
};
</script>
<template>
  <v-dialog
    v-model="value"
    max-width="600px"
  >
    <v-card v-if="module.open">
      <v-card-title>
        <span class="headline">Путевка: {{ module.open.AgreementCode }} от {{ module.open.UserName }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div class="text-h6"></div>
          <div class="body-2 mb-6" style="max-height: 40vh; overflow: auto">
            <div v-html="module.open.Text"></div>
          </div>
          <v-textarea
            outlined
            name="input-7-4"
            label="Введите сообщение"
            v-model="message"
          ></v-textarea>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="value = false">Закрыть</v-btn>
        <v-btn color="primary" :disabled="!message" @click="send">Ответить</v-btn>
      </v-card-actions>
      <v-overlay :value="module.loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </v-dialog>
</template>
<style lang="scss">

</style>
